<template>
  <div class="pravo">
    <div class="pravo__obsah">
      <div class="grid">
        <!-- TODO remove -->
        <!--<CreateGameModal>
          <div
            class="finalScreen__center__button__leave"
            style="margin: 0 0 1rem 45px"
          >
            Create game
          </div>
        </CreateGameModal>-->
        <GamesTable
          :sourceData="myActivatedGames"
          :activeGameNumber="isActivatedGame()"
          type="active"
          @action="continueGame"
        />
        <br />
        <GamesTable
          :sourceData="myOtherGames"
          :activeGameNumber="isActivatedGame()"
          type="nonactive"
          @action="continueGame"
        />
        <br />

        <GamesTable
          :sourceData="archivedGames"
          :activeGameNumber="isActivatedGame()"
          type="archived"
          @action="reviewGame"
        />
      </div>
    </div>
  </div>
</template>
<script>
import GamesTable from "@/components/gameManager/gamesTable.vue";
import { mapGetters } from "vuex";

export default {
  name: "allGames",
  components: {
    GamesTable,
  },
  methods: {
    async continueGame(game) {
      await this.$store.dispatch("setOwnerCurrentGameId", game);
      if (!game.active && game.startedTime == null) {
        await this.$store.dispatch("activateGame");
        await this.$store.dispatch("fetchOwnGames");
        await this.$store.dispatch("fetchOwnActiveGames");
        await this.$store.dispatch("fetchMe");
      } else if(game.type != "DEMO") {
        var info = await this.$router.push({
          name: this.$store.getters.joinedGame.startedTime
            ? "GameManager.game.overview"
            : "GameManager.game.lobby",
        });
      }
    },
    async reviewGame(game) {
      await this.$store.dispatch("setOwnerCurrentGameId", game);
      this.$router.push({ name: "GameManager.game.overview" });
    },
    isActivatedGame() {
      let celkem = this.myActivatedGames.length;
      let demo = this.myDemoGames.length;
      return celkem - demo;
    },
  },
  computed: {
    ...mapGetters({
      myActivatedGames: "myOwnedActivateGames",
      myDemoGames: "myOwnedActivateDemoGames",
      myOtherGames: "myOwnedGames",
      archivedGames: "myOwnedArchivedGames",
    }),
  },
};
</script>
